import script from "./Sharing.vue?vue&type=script&setup=true&lang=js"
export * from "./Sharing.vue?vue&type=script&setup=true&lang=js"

import "./Sharing.vue?vue&type=style&index=0&id=485d5629&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485d5629"]])

export default __exports__